/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * types of metadata
 */
export type MetadataType = (typeof MetadataType)[keyof typeof MetadataType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MetadataType = {
  transcript: 'transcript',
  digest: 'digest',
  thumbnail: 'thumbnail',
} as const;
